import { SVGProps } from 'react';
import { ReactComponent } from 'icons/icon-sort-down.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const SortIconDown = (props: Props) => {
  return <ReactComponent className="merc-icon-sort-down" {...props} />;
};
